import React from 'react';
import { Icon } from 'anf-core-react';
import { TmntText } from '../Common';
import { wssOrderInfoCardProps, wssOrderInfoCardDefaultProps } from './props';

function WssOrderInfoCard({ heading, status }) {
  if (!heading && !status) {
    return null;
  }

  return (
    <div className="wss-order-info-card" data-testid="wss-order-info-card">
      <div className="wss-order-info-content">
        {heading && (
          <div className="wss-order-number">
            <span className="h3" data-testid="wss-order-number">
              <TmntText tmnt={heading} />
            </span>
          </div>
        )}
        {status && (
          <div className="wss-order-status">
            {status.value && (
              <Icon
                icon={status.value}
                size="s"
                className="wss-status-icon"
                data-testid="wss-status-icon"
                aria-hidden="true"
              />
            )}
            <span className="h3" data-testid="wss-order-status">
              <TmntText tmnt={status.label} />
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

WssOrderInfoCard.propTypes = wssOrderInfoCardProps;
WssOrderInfoCard.defaultProps = wssOrderInfoCardDefaultProps;

export default WssOrderInfoCard;
